export default __webpack_public_path__ + "static/media/roku-logo.d566ba15.svg";